import { render, staticRenderFns } from "./ConstructionParams.vue?vue&type=template&id=361f5fce&scoped=true"
import script from "./ConstructionParams.vue?vue&type=script&lang=js"
export * from "./ConstructionParams.vue?vue&type=script&lang=js"
import style0 from "./ConstructionParams.vue?vue&type=style&index=0&id=361f5fce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f5fce",
  null
  
)

export default component.exports